module.exports = __webpack_public_path__ + "static/EWY_Rebecca_social-b6a7b4d87f954035192bd117b3c3aefa.mp4";